import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FileDto from './entities/File';

export interface TutorialState {
  currentFolder: Partial<FileDto> | null;
  folderStack: Partial<FileDto>[];
  detailsOpen: boolean;
  selectedFile: FileDto | null;
}

const initialState: TutorialState = {
  currentFolder: null,
  folderStack: [],
  detailsOpen: false,
  selectedFile: null,
};

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    changeCurrentFolder: (state, action: PayloadAction<Partial<FileDto> | null>) => ({
      ...state,
      currentFolder: action.payload,
    }),
    setCurrentFolder: (state, action: PayloadAction<Partial<FileDto> | null>) => ({
      ...state,
      currentFolder: action.payload,
    }),
    setDetailsOpen: (state, action: PayloadAction<boolean>) => ({
      ...state,
      detailsOpen: action.payload,
    }),
    setSelectedFile: (state, action: PayloadAction<FileDto>) => ({
      ...state,
      selectedFile: action.payload,
    }),
    setFolderStack: (state, action: PayloadAction<Partial<FileDto>[]>) => ({
      ...state,
      folderStack: action.payload,
      currentFolder: action.payload[action.payload.length - 1] ?? null,
    }),
  },
});

export const { changeCurrentFolder, setDetailsOpen, setSelectedFile, setFolderStack, setCurrentFolder } =
  tutorialSlice.actions;

export default tutorialSlice.reducer;
